
import React from 'react';
import $ from 'zzc-zepto';
import propTypes from 'prop-types';
import Map from '../Map';
import {connect} from 'react-redux';
import * as routeAction from '../../store/actions/route';

import * as tripHelper from '../../helpers/trip';
import { getLines } from '../../helpers/route';
import {isHotel, isCity} from '../../helpers/poi';
import {hotelImage} from '../../config';
import isOnLine from '../../native/isOnLine';

import './style.css';

class MapView extends React.Component {
  static propTypes = {
    renderMarkers: propTypes.bool.isRequired,
    renderLines: propTypes.bool.isRequired,
    trip: propTypes.object.isRequired,
    day: propTypes.number.isRequired,
    route: propTypes.object.isRequired,
    activePoi: propTypes.object,
    onClickMarker: propTypes.func,
    options: propTypes.object
  };

  static defaultProps = {
    route: {}
  };

  render() {
    let {renderLines, renderMarkers, onClickMarker, options} = this.props;

    return (
      <section className='component-trip-map-view'>
        {
          isOnLine()
            ? null
            : (<div className='tips'>当前为离线模式，线路更改后请连接网络进行更新</div>)
        }
        <Map
          onClickMarker={onClickMarker}
          renderMarkers={renderMarkers}
          renderLines={renderLines}
          markers={this.getMarkers()}
          lines={this.getLines()}
          options={options} />
      </section>
    );
  }

  componentWillReceiveProps(nextProps) {
    let props = this.props;
    if (nextProps.day !== props.day
      || nextProps.trip.update_time !== props.trip.update_time) {
      this.fetchRouteData(nextProps);
    }
  }

  //更新active 的层级状态
  componentDidUpdate(nextProps, nextState){
    let props = this.props;
    if(props.activePoi && props.activePoi.poi_uid && props.activePoi.poi_uid !== this.lastAcitvePoi){
      setTimeout(() => {
        $('.component-map-image-marker').removeClass('active');
        $(`[data-poi-uid="${this.lastAcitvePoi}"]`).parents('.component-map-image-marker')
          .removeClass('active').css('z-index','998');
        $(`[data-poi-uid="${props.activePoi.poi_uid}"]`).parents('.component-map-image-marker')
          .addClass('active').css('z-index','999');
        this.lastAcitvePoi = props.activePoi.poi_uid;
      }, 0);
    }
  }

  componentDidMount() {
    this.fetchRouteData(this.props);
  }

  fetchRouteData(props) {
    let {trip, day, getDayTripRoute} = props;

    getDayTripRoute(trip, day);
  }

  getMarkers() {
    let {day, trip} = this.props;
    if (day === 0) {
      return this.getCityMarkers(trip);
    } else {
      return this.getPoiMarkers(trip, day);
    }
  }

  getPoiMarkers() {
    let {trip, day, activePoi} = this.props;
    let pois = tripHelper.getPoisOfDayTrip(trip, day);
    let markers = [];
    // 不包含出发点
    let dayIndex = 0;

    pois.forEach(function (poi, index) {
      let marker = {
        type: 'imageMarker',
        source: poi,
        active: (activePoi && poi.poi_uid === activePoi.poi_uid)
      };
      // 出发点（前天酒店）
      if (day !== 1 && index === 0) {
        if (isHotel(poi)) {
          let imageUrl = isHotel(poi) ? hotelImage : poi.info.pic.small_s;

          marker = {
            ...marker,
            imageUrl: imageUrl,
            latLng: [poi.info.lat, poi.info.lng],
            message: '出发点',
          };
        } else {
          let info = poi.info;
          // fuck city
          if (isCity(poi)) {
            info = poi;
          }

          marker = {
            ...marker,
            latLng: [info.lat, info.lng],
            message: '未设置出发点',
          };
        }
      } else {
        dayIndex++;
        marker = {
          ...marker,
          latLng: [poi.info.lat, poi.info.lng],
          imageUrl: poi.info.pic.small_s,
          index: dayIndex,
        };
        markers.push(marker);
      }

      markers.push(marker);
    });

    return markers;
  }

  getCityMarkers() {
    let {trip} = this.props;
    return tripHelper.getFullTripCityMarkers(trip);
  }

  getLines() {
    let {route} = this.props;
    return getLines(route);
  }
}


export default connect(function (state, ownProps) {
  return ownProps;
}, {
  ...routeAction
})(MapView);



// WEBPACK FOOTER //
// ./src/components/TripMapView/index.js